import CryptoJS from 'crypto-js';
import axios from 'axios';
import { env } from '@ivy/fts/envInfo/envInfo';
const secret = 'AesSecretIvyDad0';
env.init();
function encrypt(cont) {
    return CryptoJS.AES.encrypt(cont, CryptoJS.enc.Utf8.parse(secret), {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
    }).ciphertext.toString(CryptoJS.enc.Base64);
}
function decrypt(text) {
    return CryptoJS.AES.decrypt({
        ciphertext: CryptoJS.enc.Base64.parse(text),
    }, CryptoJS.enc.Utf8.parse(secret), {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
    }).toString(CryptoJS.enc.Utf8);
}
// 只埋app端h5数据
export async function requireGet(url, data, config) {
    const params = data ? data : {};
    const conf = config ? config : {};
    return axios.get(url, {
        params: {
            ...params,
        },
        ...conf,
    });
}
export async function requirePost(url, data, config) {
    return axios.post(url, { ...data }, config);
}
// weex for h5 专用埋点 只埋app
export async function addStatistics(info) {
    let requestConfig = {
        disableLoading: true,
        disableAlert: true,
    };
    // 只在app内埋点
    if (env.type !== 'ivydad') {
        return;
    }
    const userInfo = (await env.getInfo()) || {};
    // const publicParams = userInfo.publicParams || {}
    // console.log('publicParams', publicParams)
    // const deviceId = publicParams.device_id || ''
    // 记录sentry日志,已告知app端，他们会修复，由于日志较多，暂时注释
    // if (!deviceId) {
    //   try {
    //     let Sentry = Vue.prototype.$sentry
    //     if (Sentry) {
    //       Sentry.withScope(scope => {
    //         scope.setTag('for', 'log-statistics')
    //         scope.setExtras({
    //           type: env.type,
    //           url: location.href,
    //           ...publicParams,
    //         })
    //         Sentry.captureMessage('empty-device-id')
    //       })
    //     } else {
    //       // 上报钉钉
    //       noticeToDing(
    //         JSON.stringify({
    //           ...publicParams,
    //           eventName: 'empty-device-id',
    //           eventType: env.type,
    //           eventUrl: location.href,
    //         })
    //       )
    //     }
    //   } catch (e) {
    //     noticeToDing(
    //       JSON.stringify({
    //         ...publicParams,
    //         eventName: 'empty-device-id',
    //         eventType: env.type,
    //         eventUrl: location.href,
    //       })
    //     )
    //     console.log(e)
    //   }
    // }
    let id = 0;
    userInfo.userInfo && userInfo.userInfo.memId
        ? (id = userInfo.userInfo.memId)
        : (id = 0);
    let url = `/api/stat/upload/eventNew?app_version=${userInfo.publicParams.version}&mem_id=${id}`;
    try {
        await requireGet(url, {
            ...info,
            client_time: new Date(),
        }, requestConfig);
    }
    catch (error) {
        console.log(error);
    }
}
export function vw2px() {
    const width = window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
    return width / 375;
}
